'use strict';

import recaptcha from '../../utils/recaptcha';
import foundationLoader from '../../utils/foundation-loader';
import logger from '../../utils/logger';

const classNames = {
	reportAdLink: 'cfs-details__at-a-glance__report-ad-link',
	reportAdForm: 'report-ad-form',
	submitButton: 'submit-button',
	failure: 'failure',
	success: 'success',
	failureText: 'failure-text',
	siteKey: 'site-key'
};

const attributes = {
	disabled: 'disabled'
};

let $modal, inputTargets, $successMessage, $failureMessage

const form = {
	init: () => {
		$modal = $.findByBem(classNames.reportAdForm);
		$successMessage = $.findByBem(classNames.reportAdForm, classNames.success);
		$failureMessage = $.findByBem(classNames.reportAdForm, classNames.failure);
		inputTargets = 'input, select, textarea';

		const reportAdLink = $.findByBem(classNames.reportAdLink);

		$(reportAdLink).on('click', (event) => {
			event.preventDefault();
			form.resetNewForm();
			$modal.foundation('open');
		});

		// Foundation event handlers must be attached after window load.
		// Otherwise Foundation is not ready when it is set.
		$(window).on('load', () => {
			const $reportAdForm = $.findByBem(classNames.reportAdForm);
			const recaptchaSiteKey = $.findByBem(classNames.reportAdForm, classNames.siteKey).data('sitekey');

			$reportAdForm.on('formvalid.zf.abide', (event, target) => {
				window.grecaptcha.ready(() => {
					window.grecaptcha.execute(recaptchaSiteKey, {action: 'submit'})
						.then(async (token) => {
							const recaptchaIsValid = await recaptcha.v3IsValidAsync(token);
							if (recaptchaIsValid) {
								form.send(target);
							} else {
								// If recaptcha fails it's a bot.
								// Just show the success message without sending the form.
								form.showSuccessMessage();
								form.disableForm();
							}
						})
						.catch((error) =>{
							form.showErrorMessage(error);
							form.disableForm();
							logger.error(error);
						});
				});
			}).on("submit", (event) => {
				event.preventDefault();
			});
		});
	},

	resetFailedForm: (failedFormElements) => {
		failedFormElements.failureMessageText.text(failedFormElements.errorMessage);
		failedFormElements.failureMessage.show();
		failedFormElements.formElements.removeAttr(attributes.disabled);
		failedFormElements.submitButton.removeAttr(attributes.disabled);
	},

	resetNewForm: () => {
		$modal.findByBem(classNames.reportAdForm, classNames.failure).hide();
		$modal.findByBem(classNames.reportAdForm, classNames.success).hide();
		$modal.findByBem(classNames.reportAdForm, classNames.submitButton).removeAttr(attributes.disabled);
		
		const $formElements = $modal.find(inputTargets);
		$formElements.removeAttr(attributes.disabled);
		$formElements.not('[type=hidden]').val('');
	},

	send: (target) => {
		// Will be overwritten by the server response if there is one
		let errorMessage = 'There was a technical error sending your message, please try again later.';

		const $formElements = $(target).find(inputTargets);
		const $failureMessage = $(target).findByBem(classNames.reportAdForm, classNames.failure);
		const $failureMessageText = $(target).findByBem(classNames.reportAdForm, classNames.failureText);
		const $submitButton = $(target).findByBem(classNames.reportAdForm, classNames.submitButton);

		$failureMessage.hide();
		$formElements.attr(attributes.disabled, attributes.disabled);
		$submitButton.attr(attributes.disabled, attributes.disabled);

		const data = {
			'first_name': $formElements.filter('#firstName').val(),
			'last_name': $formElements.filter('#lastName').val(),
			'user_email': $formElements.filter('#userEmail').val(),
			'report_text': $formElements.filter('#reportText').val() || null,
			'dealer_name': $formElements.filter('#dealerName').val() || null,
			'vehicle_source': $formElements.filter('#vehicleSource').val() || null,
			'vehicle_source_id': $formElements.filter('#vehicleSourceId').val() || null,
			'car_info': $formElements.filter('#carInfo').val(),
			'parkers_url': $formElements.filter('#parkersAdUrl').val() || null
		};

		$.ajax({
			url: '/api/report-ad/',
			method: 'post',
			contentType: 'application/json',
			data: JSON.stringify(data),
			success: () => {
				$successMessage.show();
			},
			error: (error) => {
				if (error.responseText) {
					errorMessage = error.responseText;
				}

				const failedFormElements = {
					failureMessage: $failureMessage,
					failureMessageText: $failureMessageText,
					formElements: $formElements,
					submitButton: $submitButton,
					errorMessage: errorMessage
				};

				form.resetFailedForm(failedFormElements);
			}
		});
	},

	disableForm: () => {
		$modal.find(inputTargets).attr(attributes.disabled, attributes.disabled);
		$modal.findByBem(classNames.reportAdForm, classNames.submitButton).attr(attributes.disabled, attributes.disabled);
	},

	showSuccessMessage: () => {
		$failureMessage.hide();
		$successMessage.show();
	},

	showErrorMessage: (errorMessage) => {
		$failureMessage.show();
		$modal.findByBem(classNames.reportAdForm, classNames.failureText).text(errorMessage);
	}
};

export default {
	init() {
		foundationLoader.addPlugins(foundationLoader.PLUGINS.REVEAL);
		foundationLoader.addPlugins(foundationLoader.PLUGINS.ABIDE);

		form.init();
	}
}